/* MaxPrint — branding area + print price calculator. No dependencies. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__mxbReady) return;
    var holder = root.querySelector('[data-mxb-data]');
    if (!holder) return;
    var D;
    try { D = JSON.parse(holder.textContent); } catch (e) { return; }
    if (!D || !D.areas || !D.areas.length) return;
    root.__mxbReady = true;

    var AR = !!D.rtl;
    var MM = AR ? ' مم' : ' mm';
    var T = AR ? {
      cur: 'درهم', per: 'سعر الطباعة للقطعة', printTotal: 'إجمالي الطباعة',
      item: 'سعر المنتج للقطعة', grand: 'الإجمالي التقديري', qty: 'قطعة',
      lead: 'مدة التنفيذ', quote: 'السعر عند الطلب', pcs: 'قطعة',
      volume: 'خصم الكمية',
      pProduct: 'المنتج', pPosition: 'مكان الطباعة', pMethod: 'طريقة الطباعة',
      pColours: 'عدد ألوان الشعار', pUnit: 'سعر الطباعة للقطعة', pQty: 'الكمية',
      needMethod: 'اختر طريقة الطباعة.'
    } : {
      cur: 'AED', per: 'Print price per piece', printTotal: 'Print total',
      item: 'Product price per piece', grand: 'Estimated total', qty: 'pcs',
      lead: 'Lead time', quote: 'Price on request', pcs: 'pcs',
      volume: 'Volume discount',
      pProduct: 'Product', pPosition: 'Print position', pMethod: 'Print method',
      pColours: 'Colours in your logo', pUnit: 'Print price per piece', pQty: 'Quantity',
      needMethod: 'Choose a print method.'
    };

    var byRef = {};
    (D.methods || []).forEach(function (m) { byRef[m.ref] = m; });

    /* v45: the price rows moved out of this panel and into the shared order summary
       (snippets/mx-order-summary.liquid), which is a SIBLING of the panel, not a child.
       So look inside the panel first and fall back to the document for the rows. */
    function q(sel) { return root.querySelector(sel) || document.querySelector(sel); }

    var el = {
      areas: root.querySelector('[data-mxb-areas]'),
      methods: root.querySelector('[data-mxb-methods]'),
      methodStep: root.querySelector('[data-mxb-method-step]'),
      colors: root.querySelector('[data-mxb-colors]'),
      colorStep: root.querySelector('[data-mxb-color-step]'),
      out: root.querySelector('[data-mxb-out]'),
      unit: q('[data-mxb-unit]'),
      ptotal: q('[data-mxb-ptotal]'),
      itemp: q('[data-mxb-itemprice]'),
      grand: q('[data-mxb-grand]'),
      lead: root.querySelector('[data-mxb-lead]'),
      zone: root.querySelector('[data-mxb-zone]'),
      zoneLabel: root.querySelector('[data-mxb-zone-label]'),
      wa: root.querySelector('[data-mxb-wa]'),
      tbody: root.querySelector('[data-mxb-tiers]'),
      /* order-summary hooks */
      sqty: q('[data-mxs-qty]'),
      printRow: q('[data-mxs-printrow]'),
      ptotalRow: q('[data-mxs-ptotalrow]')
    };

    var S = {
      area: 0, ref: null, colors: 1,
      qty: parseInt(D.qty_default, 10) || 50,
      price: Number(D.item_price) || 0,
      print: false
    };

    var pushQty = function () {};
    var nf2 = new Intl.NumberFormat('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var nf0 = new Intl.NumberFormat('en-AE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    function money(n, dec) {
      var s = (dec === 0 || (dec !== 2 && n >= 100)) ? nf0.format(Math.round(n)) : nf2.format(n);
      return AR ? (s + ' ' + T.cur) : (T.cur + ' ' + s);
    }

    /* Supplier rule: for a quantity between tiers, use the LOWER tier's (higher) unit price. */
    function tierFor(m, qty) {
      var t = m.tiers, pick = t[0];
      for (var i = 0; i < t.length; i++) { if (t[i][0] <= qty) pick = t[i]; else break; }
      return pick;
    }

    /* Automatic quantity discount on the PRODUCT price only (never on print).
       Mirrors the Shopify automatic discounts on the gift-items collection.
       max === null means "and above". Returns 0 when no tier applies. */
    function volumePct(tiers, qty) {
      if (!tiers || !tiers.length) return 0;
      var q = Math.max(1, parseInt(qty, 10) || 1);
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        if (q >= t.min && (t.max == null || q <= t.max)) return Number(t.pct) || 0;
      }
      return 0;
    }

    /* the Volume discount row is built here (not in Liquid) and only attached when pct > 0.
       v45: it goes into the order summary, directly under the product price per piece.
       How the discount is applied is explained once, under the tier table in
       snippets/mx-volume-tiers.liquid — this row states the figure and nothing more. */
    var volRow = null, volVal = null;
    function volumeRow() {
      if (volRow) return volRow;
      volRow = document.createElement('div');
      volRow.className = 'mxs__row';
      var lab = document.createElement('span');
      lab.textContent = T.volume;
      volVal = document.createElement('b');
      volVal.setAttribute('data-mxb-volume', '');
      volRow.appendChild(lab);
      volRow.appendChild(volVal);
      return volRow;
    }
    function renderVolume(pct, saved) {
      var total = el.grand ? el.grand.closest('.mxs__row, .mxb__row') : null;
      if (!total || !total.parentNode) return;
      var row = volumeRow();
      if (pct > 0) {
        volVal.textContent = '−' + pct + '% (' + money(saved, 2) + ')';
        var anchor = (el.printRow && el.printRow.parentNode === total.parentNode) ? el.printRow : total;
        if (row.nextSibling !== anchor || row.parentNode !== total.parentNode) {
          total.parentNode.insertBefore(row, anchor);
        }
      } else if (row.parentNode) {
        row.parentNode.removeChild(row);
      }
    }

    function chip(html, on, attrs) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mxb-chip' + (on ? ' is-on' : '');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      Object.keys(attrs || {}).forEach(function (k) { b.setAttribute(k, attrs[k]); });
      b.innerHTML = html;
      return b;
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

    function renderAreas() {
      el.areas.innerHTML = '';
      D.areas.forEach(function (a, i) {
        var size = (a.w_mm && a.h_mm) ? ('<i>' + Math.round(a.w_mm) + ' × ' + Math.round(a.h_mm) + MM + '</i>') : '';
        el.areas.appendChild(chip('<b>' + esc(AR ? (a.name_ar || a.name) : a.name) + '</b>' + size, i === S.area, { 'data-mxb-area': i }));
      });
    }

    function renderMethods() {
      var a = D.areas[S.area] || {};
      var refs = (a.methods || []).filter(function (r) { return byRef[r]; });
      el.methods.innerHTML = '';
      if (!refs.length) {
        el.methodStep.hidden = true; el.colorStep.hidden = true; el.out.hidden = true;
        S.ref = null;
        return calc();
      }
      el.methodStep.hidden = false;
      /* disambiguate identical display names by appending the size band they price */
      var names = {};
      refs.forEach(function (r) { names[byRef[r].name] = (names[byRef[r].name] || 0) + 1; });
      refs.forEach(function (r, i) {
        var m = byRef[r];
        var label = AR ? (m.name_ar || m.name) : m.name;
        var extra = '';
        if (names[m.name] > 1) {
          var t = tierFor(m, S.qty);
          extra = '<i>' + money(t[1] * 1, 2) + ' / ' + T.pcs + '</i>';
        }
        el.methods.appendChild(chip('<b>' + esc(label) + '</b>' + extra, r === S.ref, { 'data-mxb-method': r }));
      });
      if (refs.indexOf(S.ref) === -1) S.ref = refs[0];
      Array.prototype.forEach.call(el.methods.children, function (b) {
        var on = b.getAttribute('data-mxb-method') === S.ref;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      renderColors();
    }

    function renderColors() {
      var m = byRef[S.ref];
      el.colors.innerHTML = '';
      if (!m || !m.colors || m.colors.length < 2) { el.colorStep.hidden = true; S.colors = 1; return calc(); }
      el.colorStep.hidden = false;
      if (!m.colors.some(function (c) { return c[0] === S.colors; })) S.colors = m.colors[0][0];
      m.colors.forEach(function (c) {
        el.colors.appendChild(chip('<b>' + esc(AR ? c[2] : c[1]) + '</b>', c[0] === S.colors, { 'data-mxb-color': c[0] }));
      });
      calc();
    }

    function renderTiers(m) {
      if (!el.tbody) return;
      var keep = [1, 10, 25, 50, 100, 250, 500, 1000, 2000];
      var active = tierFor(m, S.qty);
      el.tbody.innerHTML = '';
      m.tiers.filter(function (t) { return keep.indexOf(t[0]) > -1; }).forEach(function (t) {
        var tr = document.createElement('tr');
        if (t[0] === active[0]) tr.className = 'is-on';
        var a = document.createElement('td'); a.textContent = nf0.format(t[0]);
        var b = document.createElement('td'); b.textContent = money(t[1] * S.colors, 2);
        tr.appendChild(a); tr.appendChild(b); el.tbody.appendChild(tr);
      });
    }

    function positionZone() {
      var a = D.areas[S.area];
      if (!el.zone) return;
      if (!a || !a.pct) { el.zone.hidden = true; return; }
      el.zone.hidden = false;
      el.zone.style.left = a.pct.x + '%';
      el.zone.style.top = a.pct.y + '%';
      el.zone.style.width = a.pct.w + '%';
      el.zone.style.height = a.pct.h + '%';
      if (el.zoneLabel) el.zoneLabel.textContent = (a.w_mm && a.h_mm) ? (Math.round(a.w_mm) + ' × ' + Math.round(a.h_mm) + MM) : (AR ? (a.name_ar || a.name) : a.name);
    }

    /* v45: calc() fills the ONE order summary. The product side (quantity, product price
       per piece, volume discount) is always computed; the print side is added only when
       the customer chose "With my logo printed". Same money() helper, same rounding and
       the same tier rules as before, so the with-printing figures are unchanged. */
    function calc() {
      pushQty();
      positionZone();

      var qty = Math.max(1, parseInt(S.qty, 10) || 1);
      var pct = volumePct(D.volume_tiers, qty);
      var net = S.price * (1 - pct / 100);
      var saved = (S.price - net) * qty;

      if (el.sqty) el.sqty.textContent = nf0.format(qty) + ' ' + T.pcs;
      if (el.itemp) {
        if (S.price && pct > 0) {
          el.itemp.innerHTML = esc(money(net, 2)) +
            ' <span style="text-decoration:line-through;opacity:.6">' + esc(money(S.price, 2)) + '</span>';
        } else {
          el.itemp.textContent = S.price ? money(S.price, 2) : '—';
        }
      }
      renderVolume(S.price ? pct : 0, saved);

      var m = byRef[S.ref];
      var printOn = !!(S.print && m);
      if (el.printRow) el.printRow.hidden = !printOn;
      if (el.ptotalRow) el.ptotalRow.hidden = !printOn;

      if (!m) {
        el.out.hidden = true;
        if (el.grand) el.grand.textContent = money(net * qty);
        return;
      }
      el.out.hidden = false;

      var t = tierFor(m, qty);
      var unit = t[1] * S.colors;
      if (el.unit) el.unit.textContent = money(unit, 2);
      if (el.ptotal) el.ptotal.textContent = money(unit * qty);
      if (el.grand) el.grand.textContent = money(printOn ? (net * qty + unit * qty) : (net * qty));

      if (el.lead) {
        var lt = AR ? m.lead_ar : m.lead;
        el.lead.parentNode.hidden = !lt;
        el.lead.textContent = lt || '';
      }
      renderTiers(m);
      if (el.wa) {
        var a = D.areas[S.area] || {};
        var lines = AR
          ? ['استفسار طباعة على منتج', D.title, 'الموضع: ' + (a.name_ar || a.name) + (a.w_mm ? ' (' + Math.round(a.w_mm) + '×' + Math.round(a.h_mm) + ' مم)' : ''), 'الطريقة: ' + (m.name_ar || m.name), 'عدد ألوان الشعار: ' + S.colors, 'الكمية: ' + qty + ' قطعة', 'سعر الطباعة التقديري: ' + money(unit, 2) + ' للقطعة', D.url]
          : ['Branding enquiry', D.title, 'Position: ' + a.name + (a.w_mm ? ' (' + Math.round(a.w_mm) + '×' + Math.round(a.h_mm) + ' mm)' : ''), 'Method: ' + m.name, 'Logo colours: ' + S.colors, 'Quantity: ' + qty + ' pcs', 'Estimated print price: ' + money(unit, 2) + ' per piece', D.url];
        el.wa.setAttribute('href', 'https://wa.me/971522100909?text=' + encodeURIComponent(lines.join('\n')));
      }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mxb-area]');
      if (b) {
        S.area = parseInt(b.getAttribute('data-mxb-area'), 10) || 0;
        Array.prototype.forEach.call(el.areas.children, function (x) {
          var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        S.ref = null; renderMethods(); return;
      }
      b = e.target.closest('[data-mxb-method]');
      if (b) { S.ref = b.getAttribute('data-mxb-method'); renderMethods(); return; }
      b = e.target.closest('[data-mxb-color]');
      if (b) { S.colors = parseInt(b.getAttribute('data-mxb-color'), 10) || 1; renderColors(); return; }
    });

    /* v43: there is exactly ONE quantity on the page — the add-to-cart input.
       The calculator reads it and writes back to it; it owns no quantity box. */
    var formQty = document.querySelector('form[action*="/cart/add"] input[name="quantity"]')
               || document.querySelector('[data-mxq-input]');
    if (formQty) {
      var fv = parseInt(formQty.value, 10);
      if (!isNaN(fv) && fv > 1) S.qty = fv;
      var syncFromForm = function () {
        var v = parseInt(formQty.value, 10);
        if (!isNaN(v) && v >= 1 && v !== S.qty) { S.qty = v; renderMethods(); }
      };
      formQty.addEventListener('input', syncFromForm);
      formQty.addEventListener('change', syncFromForm);
      pushQty = function () {
        if (parseInt(formQty.value, 10) === S.qty) return;
        formQty.value = S.qty;
        formQty.dispatchEvent(new Event('input', { bubbles: true }));
        formQty.dispatchEvent(new Event('change', { bubbles: true }));
      };
    }

    /* v45: printing is an explicit yes/no in the order summary. The radios carry a
       form="mx-no-cart-form" attribute pointing at no element, so they have no form
       owner and never reach /cart/add. "Without printing" is the default. */
    var radios = document.querySelectorAll('input[name="mx-print-choice"]');
    var panel = document.getElementById('branding') || root.closest('.mxb-acc');

    function applyPrintChoice(recalc) {
      var on;
      if (radios.length) {
        on = false;
        Array.prototype.forEach.call(radios, function (r) {
          if (r.checked && r.value === 'on') on = true;
          var lab = r.closest('.mxs__opt');
          if (lab) lab.classList.toggle('is-on', r.checked);
        });
      } else {
        /* no summary on this page (e.g. a branded product outside gift-items):
           keep the panel behaving as it always did rather than hiding it for good. */
        on = true;
      }
      S.print = on;
      if (panel) panel.hidden = !on;
      if (recalc) calc();
    }

    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener('change', function () { applyPrintChoice(true); });
    });

    /* existing #branding links still land on the printing block: follow one and the
       printing option is selected for you, which is what reveals it. */
    function openIfTargeted() {
      if (window.location.hash !== '#branding') return;
      var on = document.querySelector('input[name="mx-print-choice"][value="on"]');
      if (on && !on.checked) {
        on.checked = true;
        applyPrintChoice(true);
        if (panel && panel.scrollIntoView) panel.scrollIntoView();
      }
    }

    /* ------------------------------------------------------------------ *
       v47 — printing is charged in the cart.

       This theme has window.theme.cartType === "page": there is no AJAX add
       path to reuse. Clicking Add to cart fires a plain form submit and the
       browser POSTs to /cart/add, which Shopify answers with a redirect to
       /cart. Verified in a browser before writing this: the click produces a
       submit event with defaultPrevented === false and no fetch/XHR at all.

       So when printing is ON we take the submit over, add the two lines and then
       go to /cart — the same place the native submit lands. If the shop is ever
       switched to a drawer or message cart, we dispatch the theme's own
       product:added event instead, which is what its own AJAX branch does.

       TWO SEQUENTIAL SINGLE-ITEM CALLS, product first, then printing. Do not put
       both lines in one {items:[...]} call: that form of /cart/add.js mis-handles
       this pair and comes back 422 "Only 50 items were added to your cart due to
       availability" while still committing the printing line in full, leaving the
       customer holding printing for 200 pieces against 50 pieces of product. The
       same two adds made one at a time both succeed. Reproduced against the live
       store, cart cleared between each. See also the note on postJSON below: the
       X-Requested-With header trips the same clamp on its own.

       The pair is made atomic here, because a half-added cart is the exact failure
       this whole change exists to prevent: if the product line fails, nothing is
       added; if the product line succeeds and the printing line fails, the product
       line is removed again with /cart/change.js (quantity 0 on the key the first
       response returned) before the message is shown. No failure path navigates.

       When printing is OFF we touch nothing: the event runs on exactly as it
       does today, one line, native submit, same volume discount.

       The printing charge rides in as the quantity of a 1 AED service variant
       (D.print_service_variant, set in snippets/mx-branding-panel.liquid), so
       N units cost N dirhams. That variant is deliberately NOT in the
       gift-items collection, so it neither takes the volume discount nor counts
       toward the tier threshold.
     * ------------------------------------------------------------------ */
    var PRINT_VARIANT = parseInt(D.print_service_variant, 10) || 0;
    var adding = false;
    var notice = null;

    function showNotice(msg) {
      var host = root.querySelector('.mxb__cols') || root.querySelector('.mxb__card');
      if (!host) return;
      if (!notice) {
        notice = document.createElement('p');
        notice.className = 'mxb__needs';
        notice.setAttribute('role', 'alert');
        host.insertBefore(notice, host.firstChild);
      }
      notice.textContent = msg;
      notice.hidden = false;
    }
    function hideNotice() { if (notice) notice.hidden = true; }

    /* the print spec, in the words already on the page. No name is prefixed with
       "_": the owner reads these in the admin and on the order confirmation. */
    function specProperties(m) {
      var a = D.areas[S.area] || {};
      var p = {};
      p[T.pPosition] = AR ? (a.name_ar || a.name) : a.name;
      p[T.pMethod] = AR ? (m.name_ar || m.name) : m.name;
      if (m.colors && m.colors.length > 1) p[T.pColours] = String(S.colors);
      return p;
    }
    function printProperties(m, qty, unit, variantId) {
      var p = {};
      p[T.pProduct] = D.title + ' (' + variantId + ')';
      var spec = specProperties(m);
      Object.keys(spec).forEach(function (k) { p[k] = spec[k]; });
      p[T.pUnit] = money(unit, 2);
      p[T.pQty] = nf0.format(qty) + ' ' + T.pcs;
      return p;
    }

    function afterAdd(form, button, qty) {
      var type = (window.theme && window.theme.cartType) || 'page';
      if (type !== 'page') {
        var pf = (form.closest && form.closest('product-form')) || form;
        pf.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true, detail: { variant: null, button: button, quantity: qty }
        }));
        if (type === 'drawer') document.dispatchEvent(new CustomEvent('modal:close'));
        adding = false;
        if (button) button.removeAttribute('disabled');
        return;
      }
      window.location = (window.routes && window.routes.cartUrl) || '/cart';
    }

    /* returns true when it has taken the event over */
    function handleAdd(e, form, button) {
      if (!S.print) return false;
      var m = byRef[S.ref];

      if (!m) {
        /* printing is on but nothing priceable is selected: never add the
           product on its own without saying so. */
        e.preventDefault(); e.stopPropagation();
        if (panel) panel.hidden = false;
        showNotice(T.needMethod);
        var step = (el.methodStep && !el.methodStep.hidden) ? el.methodStep : root.querySelector('.mxb__step');
        if (step) {
          if (step.scrollIntoView) step.scrollIntoView({ block: 'center' });
          var chip = step.querySelector('.mxb-chip');
          if (chip && chip.focus) chip.focus();
        }
        return true;
      }

      e.preventDefault(); e.stopPropagation();
      if (adding) return true;
      if (form.reportValidity && !form.reportValidity()) return true;
      hideNotice();
      adding = true;
      if (button) button.setAttribute('disabled', 'disabled');

      /* Read the form through FormData, NOT querySelector. The variant id input is
         not a descendant of this form — the theme associates it with a form="..."
         attribute from elsewhere in the page, so form.querySelector('[name=id]')
         finds nothing. FormData honours form association, so it sees exactly the
         fields the native POST would have sent. (The printing radios stay out of it:
         their form="mx-no-cart-form" points at no element, so they have no owner.) */
      var fd = new FormData(form);
      var variantId = fd.get('id');
      /* the quantity the customer set reaches the cart untouched — mx-qty-cap
         has already clamped it to the variant's stock by this point. */
      var qty = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
      var unit = tierFor(m, qty)[1] * S.colors;
      var printQty = Math.round(unit * qty);

      var props = specProperties(m);
      fd.forEach(function (v, k) {
        if (typeof v !== 'string' || !v) return;
        if (k.slice(0, 11) !== 'properties[' || k.slice(-1) !== ']') return;
        props[k.slice(11, -1)] = v;
      });

      var first = { id: variantId, quantity: qty, properties: props };
      var plan = fd.get('selling_plan');
      if (plan) first.selling_plan = plan;

      var printItem = (PRINT_VARIANT && printQty >= 1)
        ? { id: PRINT_VARIANT, quantity: printQty, properties: printProperties(m, qty, unit, variantId) }
        : null;

      function fail(err) {
        adding = false;
        if (button) button.removeAttribute('disabled');
        showNotice((err && err.message) || '');
      }

      addLine(first).then(function (line) {
        if (!printItem) { afterAdd(form, button, qty); return; }
        return addLine(printItem).then(function () {
          afterAdd(form, button, qty);
        }, function (err) {
          /* the printing line did not go in: take the product line back out, so the
             customer is never left holding product with no printing. */
          return removeLine(line && line.key).then(function () { throw err; }, function () { throw err; });
        });
      }).catch(fail);
      return true;
    }

    /* No X-Requested-With header. The theme's own AJAX branch sends one and it was
       copied here at first, but on this store that header makes /cart/add.js clamp the
       line to 50 units and answer 422 "Only 50 items were added to your cart due to
       availability" — the identical symptom the {items:[...]} form produces, and a
       second, independent trigger of it. Measured against the live store, cart cleared
       between each, same variant and quantity every time:
           POST /cart/add.js  {"id":47706194182293,"quantity":200}  no header  -> 200, 200 units
           POST /cart/add.js  same body                             + header   -> 422, 50 units
           POST /cart/add     form-encoded, quantity=200            + header   -> 422, 50 units
       Shopify does not need it — the .js suffix already selects the JSON API. Leave it off. */
    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (b) { return { ok: r.ok, body: b }; },
                            function () { return { ok: r.ok, body: null }; });
      }).then(function (res) {
        if (res.ok) return res.body;
        var b = res.body;
        throw new Error((b && (b.description || b.message)) || '');
      });
    }

    /* one line at a time — see the note above on the {items:[...]} form */
    function addLine(item) {
      return postJSON(((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js', item);
    }
    function removeLine(key) {
      if (!key) return Promise.resolve();
      return postJSON(((window.routes && window.routes.cartChangeUrl) || '/cart/change') + '.js',
                      { id: key, quantity: 0 });
    }

    if (!window.__mxCartHooked) {
      window.__mxCartHooked = true;
      /* capture on document, so this runs before the theme's own delegated
         click handler on <product-form> and before the native submit. */
      document.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-action="add-to-cart"]') : null;
        if (!b) return;
        var form = b.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        if (form) handleAdd(e, form, b);
      }, true);
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.getAttribute) return;
        if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
        handleAdd(e, form, form.querySelector('[data-action="add-to-cart"]'));
      }, true);
    }

    applyPrintChoice(false);

    /* keep the product price in sync with the selected variant */
    function readVariantPrice(v) {
      if (!v) return null;
      var p = (typeof v.price === 'number') ? v.price / 100 : parseFloat(v.price);
      return isNaN(p) ? null : p;
    }
    function onVariant(e) {
      var p = readVariantPrice(e && e.detail && e.detail.variant);
      if (p != null) S.price = p;
      if (formQty) {
        var v = parseInt(formQty.value, 10);
        if (!isNaN(v) && v >= 1) S.qty = v;
      }
      calc();
    }
    document.addEventListener('variant:changed', onVariant);

    renderAreas();
    renderMethods();
    openIfTargeted();
    window.addEventListener('hashchange', openIfTargeted);
  }

  function boot() {
    document.querySelectorAll('[data-mxb]').forEach(function (n) { init(n); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();